const NEW_BOOKING_STEPS = Object.freeze({
    ownerPetDetails: {
        hash: '#owner-pet-details',
        name: 'ownerPetDetails',
        label: 'Owner, pet, and collection details',
        title: 'Owner, pet, and collection details'
    },
    productList: {
        hash: '#product-list',
        name: 'productList',
        label: 'Product details',
        title: 'Select Items'
    },
    confirmation: {
        hash: '#confirmation',
        name: 'confirmation',
        label: 'Confirmation',
        title: 'Confirmation'
    }
});

export default NEW_BOOKING_STEPS;
